export default __webpack_public_path__ + "static/media/PG.824981cc.svg";